import { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { useIntl } from 'react-intl'
import Caption from 'LuxKit/Typography/Caption'
import { getPcmTestimonialForOfferId } from 'constants/pcmTestimonials'
import Image from 'components/Common/Image'
import Sheet from 'components/utils/Sheet'

const ExpertImageContainer = styled.div`
  width: ${rem(36)};
  height: ${rem(36)};
  border-radius: ${props => props.theme.borderRadius.round};
  overflow: hidden;
`

interface Props {
  offerId: string
  className?: string
}

function OfferPagePcmTestimonial({ offerId, className }: Props) {
  const intl = useIntl()
  const testimonial = getPcmTestimonialForOfferId(offerId)

  if (!testimonial) {
    return null
  }

  return (
    <Sheet className={className} background="light-background" padding={20} borderRadius="M">
      <Group direction="vertical" gap={12}>
        <Heading variant="heading5">
          {intl.formatMessage({
            id: 'VQEsYv4X2AuAvjOKLH4C',
            defaultMessage: 'Our travel expert’s take',
            description: 'Heading for a testimonial section from a travel expert on the offer page.',
          })}
        </Heading>
        <Group direction="horizontal" gap={8} verticalAlign="center">
          <ExpertImageContainer>
            <Image
              id={testimonial.imageId}
              alt={testimonial.name}
              fit="center"
              objectFit="cover"
            />
          </ExpertImageContainer>
          <div>
            <BodyText variant="medium">
              {testimonial.name}
            </BodyText>
            <Caption variant="medium" colour="neutral-three">
              {intl.formatMessage({
                id: 'SFjamr0hU93fP9KlK8FO',
                defaultMessage: 'Partnerships Manager, Luxury Escapes',
                description: 'Job title for the travel expert shown alongside their offer page testimonial.',
              })}
            </Caption>
          </div>
        </Group>
        <BodyText variant="medium">
          {intl.formatMessage({
            id: 'PNt2neMc0D5V0ZsRlLqn',
            defaultMessage: '“{review}”',
            description: 'Review text shown in the offer page travel expert testimonial section.',
          }, { review: testimonial.review })}
        </BodyText>
      </Group>
    </Sheet>
  )
}

export default memo(OfferPagePcmTestimonial)
